import { createFileRoute } from '@tanstack/react-router'

import { NoCardsInStack } from '~/boundedContext/cards/pages/no-cards-in-stack'

export const Route = createFileRoute('/demo/_layout/cards/no-cards-in-stack')({
  component: NoCardsInStack,
})
